import FxTable from './FxTable';

export default FxTable;
